export const environment = {
  production: true,
  notifications: false,
  env: 'PRO',
  url: 'qsignerback.quiteraws.com',
  urlPolls: 'narobial.quiter.com',
  urlQSigner: 'https://pilotajesweb.quiter.com:4500',
  urlQWebPrinter: 'https://pilotajesweb.quiter.com:4000',
  ERROR_API_CODES: ['api_error', 'dms_error', 'dms_connection_error', 'qxservices_error', 'unauthorized_client', 'rate_limit_exceeded'],
  WARNING_API_CODES: ['record_not_found', 'dms_warning', 'no_records_found', 'too_many_records'],
  narobial_url: 'https://bncbo.narobial.net',
};
